import React from "react";
import { useAuth0 } from '@auth0/auth0-react';

function LoginAuth0() {
  const { loginWithRedirect } = useAuth0();

  // ⭐ OS detection function (matches BetaGatePage and Auth0Component)
  const getOS = () => {
    const userAgent = window.navigator.userAgent;
    if (userAgent.indexOf("Win") !== -1) return "windows";
    if (userAgent.indexOf("Mac") !== -1) return "macos";
    if (userAgent.indexOf("Linux") !== -1) return "linux";
    return "unknown";
  };

  const handleLogin = () => {
    const os = getOS();
    console.log(`Redirecting to login with OS: ${os}`);
    window.location.href = `https://www.enlive.inc/login?os=${os}`;
  };

  return (
    <a
      className="enlive-nav-link"
      href="#"
      onClick={(e) => {
        e.preventDefault();
        handleLogin();
      }}
    >
      Login
    </a>
  );
}

export default LoginAuth0;